import { memo } from 'react'

const Vidita = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={170}
    height={190}
    fill="none"
    viewBox='0 0 170 190'
    {...props}
  >
    <path
      fill="#E8BB2D"
      d="M73.656 140.057a5.008 5.008 0 0 0-7.062 0L52.977 153.67a5.004 5.004 0 0 0 0 7.06 5.008 5.008 0 0 0 7.062 0l13.617-13.613a5.005 5.005 0 0 0 0-7.06ZM111.19 153.67l-13.617-13.613a5.008 5.008 0 0 0-7.062 0c-1.943 1.94-1.943 5.117 0 7.06l13.617 13.613c1.942 1.942 5.119 1.942 7.062 0 1.942-1.941 1.942-5.118 0-7.06Z"
    />
    <path
      fill="#E8BB2D"
      d="M81.701 74.85c0-36.496-29.593-66.081-66.1-66.081v66.08c0 36.498 29.593 66.084 66.1 66.084 36.508 0 66.1-29.586 66.1-66.083V8.769c-36.508 0-66.1 29.585-66.1 66.08Z"
    />
    <path
      stroke="#2B4C30"
      strokeMiterlimit={10}
      strokeWidth={3}
      d="M88.052 119.767a6.892 6.892 0 0 1-8.628 4.53"
    />
    <path
      fill="#E8BB2D"
      d="m78.027 181.88 1.642-8.638c-7.95 0-14.455-6.503-14.455-14.451v-7.496c0-7.949 6.504-14.451 14.455-14.451h6.22c7.951 0 14.455 6.502 14.455 14.451v7.496c0 7.948-14.366 23.089-22.317 23.089Z"
    />
    <path
      fill="#fff"
      d="M48.391 112.166c7.76 0 14.052-6.29 14.052-14.048S56.152 84.07 48.39 84.07c-7.76 0-14.051 6.29-14.051 14.048s6.29 14.048 14.051 14.048Z"
    />
    <path
      fill="#3FA9F5"
      d="M75.824 99.582c0 14.617-11.852 26.466-26.474 26.466s-26.474-11.849-26.474-26.466c0-14.618-.82-21.447 13.788-22.056 39.71-1.654 39.16 7.438 39.16 22.056ZM89.054 99.582c0 14.617 11.852 26.466 26.473 26.466 14.622 0 26.474-11.849 26.474-26.466 0-14.618.82-21.447-13.788-22.056-39.71-1.654-39.16 7.438-39.16 22.056Z"
      opacity={0.31}
    />
    <path
      fill="#2B4C30"
      d="M156.352 76.924a2.758 2.758 0 0 0-3.141-1.589c-4.388.998-8.922 2.029-13.116 1.21-.343-.068-.706-.15-1.098-.252a12.896 12.896 0 0 0-1.654-.885 2.775 2.775 0 0 0-1.732-.171c-2.18-.73-4.455-1.453-7.285-1.571-22.069-.918-33.29 1.291-38.414 7.62-2.053 1.241-4.693 1.947-7.67 2.047-2.369.078-4.81-.206-7.147-.575-4.774-7.095-16.01-9.502-39.1-8.54-3.55.148-6.259 1.139-8.88 2.097-.956.35-1.947.711-2.971 1.03-3.566 1.104-7.954 1.316-12.199 1.521a178.48 178.48 0 0 0-3.863.215 2.756 2.756 0 0 0-2.407 1.84c-1.818 5.204-.596 11.201 3.113 15.281 1.385 1.522 3.403 1.745 4.8.531.615-.534.988-1.268 1.111-2.18.197-1.479.113-2.965-.252-4.413l-.017-.067 5.103.07c-.091 1.98-.05 3.951-.01 5.88.02 1.015.042 2.021.042 3.008 0 16.113 13.113 29.223 29.23 29.223 16.118 0 29.232-13.11 29.232-29.223v-.563c0-1.863.002-3.645-.083-5.355.189-.153.386-.312.446-.349 1.063-.522 2.301-.802 3.586-.805 1.383.016 2.828.274 4.389.846-.074 1.638-.072 3.343-.072 5.116v.556c0 16.113 13.113 29.223 29.231 29.223 16.117 0 29.231-13.11 29.231-29.223 0-.75.002-1.478.003-2.187.009-3.079.018-5.86-.163-8.318.848-.135 1.675-.29 2.479-.464l.139-.03c.245-.053.507-.11.741-.15-.074.781-.044 1.869.695 2.912 1.202 1.7 3.61 2.129 5.478.98 1.264-.776 1.89-1.985 2.251-2.827a14.51 14.51 0 0 0-.03-11.472l.004.003Zm-84 15.158c.165 1.925.164 4.09.164 6.384v.565c0 13.073-10.64 23.71-23.717 23.71-13.076 0-23.716-10.637-23.716-23.71 0-1.026-.02-2.07-.044-3.125-.058-2.718-.116-5.529.233-8.108.105-.783-1.292-8.066 10.956-8.068 26.96-.005 32.714 3.07 34.737 6.847.403.751 1.304 4.53 1.387 5.505Zm66.48-6.03c.436 2.624.427 6.146.415 10.226a779.82 779.82 0 0 0-.004 2.202c0 13.073-10.639 23.71-23.716 23.71-13.076 0-23.716-10.637-23.716-23.71v-.56c0-2.386.137-11.357 1.501-12.256.268-.176.502-.398.694-.654 3.628-4.863 14.141-6.66 34.091-5.83 2.196.091 4.093.728 6.103 1.403.385.129 3.947 1.355 4.632 5.47Z"
    />
    <path
      fill="#fff"
      d="M123.645 91.236c6.822 0 12.352-2.236 12.352-4.993 0-2.758-5.53-4.993-12.352-4.993s-12.352 2.235-12.352 4.993c0 2.757 5.53 4.993 12.352 4.993ZM52.687 91.76c6.821 0 12.351-2.235 12.351-4.993 0-2.757-5.53-4.993-12.351-4.993-6.822 0-12.352 2.236-12.352 4.993 0 2.758 5.53 4.993 12.352 4.993Z"
      opacity={0.3}
    />
    <path
      fill="#2B4C30"
      d="M48.391 109.155c6.098 0 11.04-4.941 11.04-11.037 0-6.096-4.942-11.038-11.04-11.038-6.097 0-11.04 4.942-11.04 11.038s4.943 11.037 11.04 11.037ZM127.487 108.098h-4.771c0-4.771-3.882-8.654-8.656-8.654-4.775 0-8.657 3.883-8.657 8.654h-4.77c0-7.401 6.023-13.423 13.427-13.423 7.403 0 13.427 6.022 13.427 13.423Z"
    />
  </svg>
)

export default memo(Vidita)
